import { variables } from '../variables';
import AvenirNextBold from '../../fonts/HardAssetsAlliance/AvenirNext-Bold.woff2';
import AvenirNextDemiBold from '../../fonts/HardAssetsAlliance/AvenirNext-DemiBold.woff2';
import AvenirNextMedium from '../../fonts/HardAssetsAlliance/AvenirNext-Medium.woff2';
import AvenirNextRegular from '../../fonts/HardAssetsAlliance/AvenirNext-Regular.woff2';

export const gbiDirectColors = {
  // Primary colors
  colorPrimary: '#3343A3',
  colorPrimaryLight: '#3E51C4',
  colorPrimaryDark: '#253176',
  colorProgressBarDefault: '#EEEEEE',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#B73030',
  colorGrey: '#EEEEEE',

  // Button colors
  colorButtonPrimary: '#3343A3',
  colorButtonPrimaryInactive: '#E9EDFA',
  colorButtonPrimaryActive: '#253176',
  colorButtonSecoundary: '#333333', // don't use
  colorButtonSecondaryActive: '#222222', // don't use
  colorButtonOutlined: '#ffffff',
  colorButtonOutlinedBorder: '#3343A3',
  colorButtonOutlinedText: '#3343A4',

  // Icon
  colorCheckedIcon: '#008C5B',
  colorSuccess: '#008C5B',

  // Text
  colorTextPrimary: '#3343A3', // blue
  colorTextSecondary: '#0B0E1A', // semiDark
  colorTextOutline: '#333333', // blueOutline
  colorTextLight: 'rgba(51,51,51,0.5)', // light
  colorTextXLLight: '#333333', // XL light
  colorTextGrey: 'rgba(51,51,51)', // grey
  colorTextGrey5: '#333333', // grey 5
  colorTextGrey6: '#222222', // grey6
  colorTextError: '#B73030', // red
  colorLink: '#3343A3', // semiDark

  // Backgrounds
  colorBackgroundPrimary: '#ffffff', // white
  colorBackgroundPrimaryDark: '#E9EDFA', // whitish
  colorBackgroundSecondary: '#EEEEEE', // xlGrey
  colorBackgroundSecondaryLight: '#E9EDFA', // light grey
  colorBackgroundSecondaryDark: '#0B0E1A', // dark
  colorBackgroundSecondaryDark1: '#EEEEEE', // dark1
  colorBackgroundDropzone: '#EEEEEE', // grey2
  colorBackgroundModal: 'rgba(51,51,51,0.55)',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#E9EDFA', // grey
  colorBorderPrimaryDark: '#EEEEEE', // grey2
  colorBorderSecondary: '#EBA000', // yellow
  colorBorderSemiDark: 'rgba(51,51,51,0.3)',
  colorsDivider: '#EEEEEE', // outline

  // svg colors
  colorSvgSemidark: '#3343A3',

  // Input
  colorInputBackground: '#3343A3',
  colorErrorMessage: '#B73030',

  // Banner
  colorMisingInfoBackgorund: '#FFE8E8',
  colorMissingInfoText: '#B73030',

  // Border
  colorBorder: '#3343A3',

  // Footer Colors
  colorFooterBackground: '#0B0E1A',
  colorFooterText: '#FFFFFF',

  // Loader
  colorLoader: '#3343A3',
};

export const hardAssetsAllianceFonts = `
  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextDemiBold}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  *,
  *::after,
  *::before {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
  }
`;
